// extracted by mini-css-extract-plugin
export default {"curriculumListContainer":"CurriculumList__curriculumListContainer___Ux0Qg"};